import { render } from "./AvailabilityChart.vue?vue&type=template&id=2a5f228b&scoped=true"
import script from "./AvailabilityChart.vue?vue&type=script&lang=js"
export * from "./AvailabilityChart.vue?vue&type=script&lang=js"

import "./AvailabilityChart.vue?vue&type=style&index=0&id=2a5f228b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5f228b"]])

export default __exports__